import './StructuralRealitySection.scss'

const STRUCTURAL_VARIABLES = ['roles', 'functions', 'sites', 'incentives', 'risk exposure']

const StructuralRealitySection = () => (
  <section className="lnn-section lnn-section--alt lnn-structuralSection">
    <div className="lnn-shell" data-reveal="up">
      <div className="lnn-structuralSection__head">
        <h2>The Structural Reality</h2>
      </div>

      <div className="lnn-structuralSection__content">
        <div className="lnn-structuralSection__primary">
          <p>A decision does not move directly from intent to execution.</p>
          <p>It passes through interpretation first.</p>
          <p>That interpretation determines what people do next.</p>
        </div>

        <div className="lnn-structuralSection__variables">
          <p>In complex organizations, interpretation varies across:</p>

          <ul>
            {STRUCTURAL_VARIABLES.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="lnn-structuralSection__result">
          <p>This is not a communication issue.</p>
          <p>It is structural.</p>
        </div>
      </div>
    </div>
  </section>
)

export default StructuralRealitySection
